import tw from 'twin.macro';

const InputContainer = tw.div`flex flex-col w-full p-2 px-0`;
const Label = tw.label`text-xs font-bold font-sans mt-0 mb-2`;
const ErrorMessage = tw.div`mx-auto text-sm rounded-md text-red-600 font-bold font-sans`;
const SuccessMessage = tw.div`bg-swell-gray bg-opacity-10 w-full md:w-4/5 lg:w-1/2 p-4 my-2 mx-auto text-sm text-center leading-loose rounded-md font-sans`;

export { InputContainer, Label, ErrorMessage, SuccessMessage };
